/** Montants TND — format harmonisé (millimes, séparateur milliers) */
export const formatTND = (amount) => {
  const value = Number(amount ?? 0)
  if (Number.isNaN(value)) return '0,000'
  return value.toLocaleString('fr-TN', {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  })
}
